module.exports = __webpack_public_path__ + "img/horizontal_6_5_4.50bbdf60.png";